import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import { assetsCdnUrl } from '~/constants/environment';
import type { SeoContent } from '~/contracts/srp/Seo';
import { SizeList } from './constants';
import { getSrcSet, contentJpg } from './utilities';

const smallSrcSet = (ext: string) => (url: string) =>
  getSrcSet(SizeList.small)(ext)(url);
const mediumSrcSet = (ext: string) => (url: string) =>
  getSrcSet(SizeList.medium)(ext)(url);
const largeSrcSet = (ext: string) => (url: string) =>
  getSrcSet(SizeList.large)(ext)(url);

type OwnProps = {
  contentMods: SeoContent;
};

export default function ContentPicture({ contentMods: mods }: OwnProps) {
  return (
    <picture>
      <source
        media={`(min-width: ${legacyBreakpoints.l}px)`}
        type="image/webp"
        srcSet={largeSrcSet('webp')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media={`(min-width: ${legacyBreakpoints.l}px)`}
        type="image/jp2"
        srcSet={largeSrcSet('jp2')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media={`(min-width: ${legacyBreakpoints.l}px)`}
        type="image/jxr"
        srcSet={largeSrcSet('jxr')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media={`(min-width: ${legacyBreakpoints.l}px)`}
        type="image/jpg"
        srcSet={largeSrcSet('jpg')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />

      <source
        media={`(min-width: ${legacyBreakpoints.s}px)`}
        type="image/webp"
        srcSet={mediumSrcSet('webp')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media={`(min-width: ${legacyBreakpoints.s}px)`}
        type="image/jp2"
        srcSet={mediumSrcSet('jp2')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media={`(min-width: ${legacyBreakpoints.s}px)`}
        type="image/jxr"
        srcSet={mediumSrcSet('jxr')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media={`(min-width: ${legacyBreakpoints.s}px)`}
        type="image/jpg"
        srcSet={mediumSrcSet('jpg')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />

      <source
        media="(min-width: 0px)"
        type="image/webp"
        srcSet={smallSrcSet('webp')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media="(min-width: 0px)"
        type="image/jp2"
        srcSet={smallSrcSet('jp2')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media="(min-width: 0px)"
        type="image/jxr"
        srcSet={smallSrcSet('jxr')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />
      <source
        media="(min-width: 0px)"
        type="image/jpg"
        srcSet={smallSrcSet('jpg')(mods.contentMod.imageURL)(assetsCdnUrl)}
      />

      <img
        src={contentJpg(`${mods.contentMod.imageURL}.1048x640`)(assetsCdnUrl)}
        alt={mods.contentMod.imageAltText}
        loading="lazy"
      />
    </picture>
  );
}
